var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('main-nav'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('back-to-top'),_vm._v(" "),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }